import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowContainerStyleMarginValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'string',
            empty: false,
            mandatory: false
        };
    }
}
